module.exports = __webpack_public_path__ + "static/media/CreateGroupIcon.7625e07c.svg";